"use strict";

var _require = require("@pwops/core"),
    registerMixin = _require.registerMixin;

var _flexbox = function _flexbox(type, direction, mainAxis, secondaryAxis, wrap) {
  var entries = {
    display: type
  };
  direction && (entries.flexDirection = direction);
  mainAxis && (entries.justifyContent = mainAxis);
  secondaryAxis && (entries.alignItems = secondaryAxis);
  wrap && (entries.flexWrap = wrap);
  return entries;
};

registerMixin("flexBox", function () {
  for (var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++) {
    values[_key] = arguments[_key];
  }

  return _flexbox.apply(void 0, ["flex"].concat(values));
});
registerMixin("inlineFlexBox", function () {
  for (var _len2 = arguments.length, values = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    values[_key2] = arguments[_key2];
  }

  return _flexbox.apply(void 0, ["inline-flex"].concat(values));
});
registerMixin("flexRow", function () {
  for (var _len3 = arguments.length, values = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    values[_key3] = arguments[_key3];
  }

  return _flexbox.apply(void 0, ["flex", "row"].concat(values));
});
registerMixin("inlineFlexRow", function () {
  for (var _len4 = arguments.length, values = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
    values[_key4] = arguments[_key4];
  }

  return _flexbox.apply(void 0, ["inline-flex", "row"].concat(values));
});
registerMixin("flexRowReverse", function () {
  for (var _len5 = arguments.length, values = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
    values[_key5] = arguments[_key5];
  }

  return _flexbox.apply(void 0, ["flex", "row-reverse"].concat(values));
});
registerMixin("inlineFlexRowReverse", function () {
  for (var _len6 = arguments.length, values = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
    values[_key6] = arguments[_key6];
  }

  return _flexbox.apply(void 0, ["inline-flex", "row-reverse"].concat(values));
});
registerMixin("flexColumn", function () {
  for (var _len7 = arguments.length, values = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
    values[_key7] = arguments[_key7];
  }

  return _flexbox.apply(void 0, ["flex", "column"].concat(values));
});
registerMixin("inlineFlexColumn", function () {
  for (var _len8 = arguments.length, values = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
    values[_key8] = arguments[_key8];
  }

  return _flexbox.apply(void 0, ["inline-flex", "column"].concat(values));
});
registerMixin("flexColumnReverse", function () {
  for (var _len9 = arguments.length, values = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
    values[_key9] = arguments[_key9];
  }

  return _flexbox.apply(void 0, ["flex", "column-reverse"].concat(values));
});
registerMixin("inlineFlexColumnReverse", function () {
  for (var _len10 = arguments.length, values = new Array(_len10), _key10 = 0; _key10 < _len10; _key10++) {
    values[_key10] = arguments[_key10];
  }

  return _flexbox.apply(void 0, ["inline-flex", "column-reverse"].concat(values));
});